import { Text } from '@chakra-ui/react'

const BodyText = ({ children }: { children: React.ReactNode }) => {
  return <Text whiteSpace="pre-line">{children}</Text>
}

export default BodyText
